export const preloadImages = (urls) => {
    const promises = urls.map((url) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = resolve;
            img.onerror = resolve; // Resolve even on error to avoid blocking the app
        });
    });

    return Promise.all(promises);
};
